import { useParams } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { EditObjectStepScreen } from 'widgets/kyrgyzstan/edit-object-editor'

import {
  CreateObjectStepId,
  editObjectSessionStore,
} from 'entities/kyrgyzstan/model'

const KyrgyzstanRejectedObjectEditStepPage = observer(() => {
  const { draftId: sourceDraftId, stepId } = useParams<{
    draftId: string
    stepId: string
  }>() as {
    draftId: string
    stepId: string
  }
  const parentPath =
    RoutingPaths.kyrgyzstan.objects.draftRevision.path(sourceDraftId)

  return (
    <EditObjectStepScreen
      draftId={editObjectSessionStore.draftId}
      parentPath={parentPath}
      stepId={stepId}
      getStepPath={(nextStepId: CreateObjectStepId) =>
        RoutingPaths.kyrgyzstan.objects.draftRevision.step.path(
          sourceDraftId,
          nextStepId,
        )
      }
    />
  )
})

export default KyrgyzstanRejectedObjectEditStepPage
